var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-layout', {
    attrs: {
      "width": "100%",
      "max-width": "600"
    }
  }, [_c('console-title', [_vm.$route.params._admin ? _c('span', [_vm._v("관리자 상세")]) : _c('span', [_vm._v("관리자 생성")])]), _c('console-body', [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-2"
  }, [_vm._v("기본정보")]), _c('v-card-text', [_c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "아이디",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.admin.username,
      callback: function callback($$v) {
        _vm.$set(_vm.admin, "username", $$v);
      },
      expression: "admin.username"
    }
  }), _c('v-password-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "비밀번호",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.admin.password,
      callback: function callback($$v) {
        _vm.$set(_vm.admin, "password", $$v);
      },
      expression: "admin.password"
    }
  })], 1), _c('v-divider'), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "담당자(이름)",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.admin.name,
      callback: function callback($$v) {
        _vm.$set(_vm.admin, "name", $$v);
      },
      expression: "admin.name"
    }
  }), _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "담당자(연락처)",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.admin.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.admin, "phone", $$v);
      },
      expression: "admin.phone"
    }
  }), _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "담당자(이메일)",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.admin.email,
      callback: function callback($$v) {
        _vm.$set(_vm.admin, "email", $$v);
      },
      expression: "admin.email"
    }
  })], 1), _c('v-divider'), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "우편번호",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.admin.postcode,
      callback: function callback($$v) {
        _vm.$set(_vm.admin, "postcode", $$v);
      },
      expression: "admin.postcode"
    }
  }), _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "기본주소",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.admin.address1,
      callback: function callback($$v) {
        _vm.$set(_vm.admin, "address1", $$v);
      },
      expression: "admin.address1"
    }
  }), _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "상세주소",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.admin.address2,
      callback: function callback($$v) {
        _vm.$set(_vm.admin, "address2", $$v);
      },
      expression: "admin.address2"
    }
  })], 1), _c('v-divider'), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "ci",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.admin.ci,
      callback: function callback($$v) {
        _vm.$set(_vm.admin, "ci", $$v);
      },
      expression: "admin.ci"
    }
  })], 1), _c('v-card-actions')], 1)], 1), _c('v-row', {
    staticClass: "my-4"
  }, [_c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1), _c('v-spacer')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }